import { render, staticRenderFns } from "./DeepLink.vue?vue&type=template&id=01fd8a45&"
import script from "./DeepLink.vue?vue&type=script&lang=js&"
export * from "./DeepLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports